var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSoil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_69_1606",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#5D38E5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_69_1606)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 80,
    fill: "#5D38E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3724 103.579C63.3724 103.579 53.9991 96.5896 48.2154 92.2552C42.1336 87.6905 37.4064 89.6274 33.6002 93.4336L59.3088 117.639C61.4219 119.63 64.2257 120.741 67.1379 120.741H100.188",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.516 107.412C106.717 99.1224 101.204 95.9258 94.4042 95.9258C88.5121 95.9258 85.3831 96.6166 80.3579 99.9893H69.576C67.8422 99.9893 62.1262 100.761 62.1262 109.173H84.8143",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.208 111.719L117.702 103.227L93.5645 127.364L102.071 135.87",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5998 88.8C29.5998 77.6 43.0245 69.5887 50.6818 69.5887C52.6085 69.5887 54.4364 69.9981 56.0913 70.7146C57.4993 64.1385 63.1558 59.2 69.9486 59.2C74.8641 59.2 79.2115 61.7843 81.7557 65.7505C83.7318 63.1917 86.7206 61.5285 90.1293 61.5285C95.6871 61.5285 100.232 65.9296 100.775 71.5334C101.763 71.2775 102.801 71.124 103.863 71.124C110.458 71.124 115.843 76.4463 116.238 83.176C120.622 83.9925 125.73 92.2382 121.6 101.6",
    stroke: "white",
    strokeWidth: 6.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.4,
    cy: 66.3999,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 42.3999,
    cy: 55.2,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 76,
    cy: 45.6001,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.8,
    cy: 32.8,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.4,
    cy: 52,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 34.3999,
    r: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64.8,
    cy: 81.5999,
    rx: 4,
    ry: 3.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.6,
    cy: 88,
    rx: 4,
    ry: 3.2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.6001,
    cy: 91.2,
    rx: 4,
    ry: 3.2,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoil);
export default __webpack_public_path__ + "static/media/icon_soil.be27a589a1ad4f83d16a86707a9c41b2.svg";
export { ForwardRef as ReactComponent };